export default __webpack_public_path__ + "static/media/email.74a8750b.svg";